import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-generic-confirmation-modal',
  templateUrl: './generic-confirmation-modal.component.html',
  styleUrls: ['./generic-confirmation-modal.component.css'],
})
export class GenericConfirmationModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}
}
